export enum NoticeType {
    Info = 'info',
    Warning = 'warning',
    Error = 'error'
}
